export default __webpack_public_path__ + "static/media/PD2576_16389-USONV-New-Patient-Packet_081519_V5d_test.e86a63c1.pdf";